/**
 * Extracts meeting information from the component
 * @param component A component that contains information about the meeting by implementing ComponentMeetingInformation
 * @returns A promise to the meeting information or undefined if the component doesn't contain meeting information
 */ export async function getMeetingInformation(component) {
    const meetingsProvider = component;
    const meetingInformation = await meetingsProvider.ComponentMeetingInformationProvider?.getMeetingInformation();
    return meetingInformation;
}
/**
 * Determines whether the given meeting information is for an occurrence of a meeting series
 * @param meetingInformation Information about the meeting
 * @returns true if meeting note is for an occurence of a meeting series, undefined if inconclusive due to missing information
 */ export function isSeriesOccurrenceMeetingNote(meetingInformation) {
    return meetingInformation.meetingId !== undefined && meetingInformation.seriesId !== undefined && meetingInformation.meetingId !== meetingInformation.seriesId;
}
/**
 * Determines whether the given meeting information is for a series template meeting note for a series master meeting
 * @param meetingInformation Information about the meeting
 * @returns true if series template meeting note, undefined if inconclusive due to missing information
 */ export function isSeriesTemplateMeetingNote(meetingInformation) {
    return meetingInformation.seriesId !== undefined && meetingInformation.isShared;
}
/**
 * Determines whether the given meeting information is for a single instance meeting or not. ie: Not part of a meeting series
 * @param meetingInformation Information about the meeting
 * @returns true if meeting note is for a single instance meeting, undefined if inconclusive due to missing information
 */ export function isSingleInstanceMeetingNote(meetingInformation) {
    // Ideally seriesId should be empty in this case, but there's a bug in Teams where if seriesId is empty, they duplicate meetingId's value in seriesId too.
    return meetingInformation.seriesId === undefined || meetingInformation.meetingId === meetingInformation.seriesId;
}
